const darkColorMap = {
  'text-inherit': 'dark:text-inherit',

  // Gray
  'text-white': 'dark:text-gray-900',
  'text-gray-50': 'dark:text-gray-800',
  'text-gray-100': 'dark:text-gray-700',
  'text-gray-200': 'dark:text-gray-600',
  'text-gray-300': 'dark:text-gray-500',
  'text-gray-400': 'dark:text-gray-400',
  'text-gray-500': 'dark:text-gray-300',
  'text-gray-600': 'dark:text-gray-200',
  'text-gray-700': 'dark:text-gray-100',
  'text-gray-800': 'dark:text-gray-50',
  'text-gray-900': 'dark:text-white',

  // Green
  'text-green-50': 'dark:text-green-900',
  'text-green-100': 'dark:text-green-800',
  'text-green-200': 'dark:text-green-700',
  'text-green-300': 'dark:text-green-600',
  'text-green-400': 'dark:text-green-500',
  'text-green-500': 'dark:text-green-400',
  'text-green-600': 'dark:text-green-300',
  'text-green-700': 'dark:text-green-200',
  'text-green-800': 'dark:text-green-100',
  'text-green-900': 'dark:text-green-50',

  // Emerald
  'text-emerald-50': 'dark:text-emerald-900',
  'text-emerald-100': 'dark:text-emerald-800',
  'text-emerald-200': 'dark:text-emerald-700',
  'text-emerald-300': 'dark:text-emerald-600',
  'text-emerald-400': 'dark:text-emerald-500',
  'text-emerald-500': 'dark:text-emerald-400',
  'text-emerald-600': 'dark:text-emerald-300',
  'text-emerald-700': 'dark:text-emerald-200',
  'text-emerald-800': 'dark:text-emerald-100',
  'text-emerald-900': 'dark:text-emerald-50',

  // Red
  'text-red-50': 'dark:text-red-900',
  'text-red-100': 'dark:text-red-800',
  'text-red-200': 'dark:text-red-700',
  'text-red-300': 'dark:text-red-600',
  'text-red-400': 'dark:text-red-500',
  'text-red-500': 'dark:text-red-400',
  'text-red-600': 'dark:text-red-300',
  'text-red-700': 'dark:text-red-200',
  'text-red-800': 'dark:text-red-100',
  'text-red-900': 'dark:text-red-50',

  // Yellow
  'text-yellow-50': 'dark:text-yellow-900',
  'text-yellow-100': 'dark:text-yellow-800',
  'text-yellow-200': 'dark:text-yellow-700',
  'text-yellow-300': 'dark:text-yellow-600',
  'text-yellow-400': 'dark:text-yellow-500',
  'text-yellow-500': 'dark:text-yellow-400',
  'text-yellow-600': 'dark:text-yellow-300',
  'text-yellow-700': 'dark:text-yellow-200',
  'text-yellow-800': 'dark:text-yellow-100',
  'text-yellow-900': 'dark:text-yellow-50',

  // Indigo
  'text-indigo-50': 'dark:text-indigo-900',
  'text-indigo-100': 'dark:text-indigo-800',
  'text-indigo-200': 'dark:text-indigo-700',
  'text-indigo-300': 'dark:text-indigo-600',
  'text-indigo-400': 'dark:text-indigo-500',
  'text-indigo-500': 'dark:text-indigo-400',
  'text-indigo-600': 'dark:text-indigo-300',
  'text-indigo-700': 'dark:text-indigo-200',
  'text-indigo-800': 'dark:text-indigo-100',
  'text-indigo-900': 'dark:text-indigo-50',

  // Blue
  'text-blue-50': 'dark:text-blue-900',
  'text-blue-100': 'dark:text-blue-800',
  'text-blue-200': 'dark:text-blue-700',
  'text-blue-300': 'dark:text-blue-600',
  'text-blue-400': 'dark:text-blue-500',
  'text-blue-500': 'dark:text-blue-400',
  'text-blue-600': 'dark:text-blue-300',
  'text-blue-700': 'dark:text-blue-200',
  'text-blue-800': 'dark:text-blue-100',
  'text-blue-900': 'dark:text-blue-50',

  // Orange
  'text-orange-50': 'dark:text-orange-900',
  'text-orange-100': 'dark:text-orange-800',
  'text-orange-200': 'dark:text-orange-700',
  'text-orange-300': 'dark:text-orange-600',
  'text-orange-400': 'dark:text-orange-500',
  'text-orange-500': 'dark:text-orange-400',
  'text-orange-600': 'dark:text-orange-300',
  'text-orange-700': 'dark:text-orange-200',
  'text-orange-800': 'dark:text-orange-100',
  'text-orange-900': 'dark:text-orange-50',

  // Amber
  'text-amber-50': 'dark:text-amber-900',
  'text-amber-100': 'dark:text-amber-800',
  'text-amber-200': 'dark:text-amber-700',
  'text-amber-300': 'dark:text-amber-600',
  'text-amber-400': 'dark:text-amber-500',
  'text-amber-500': 'dark:text-amber-400',
  'text-amber-600': 'dark:text-amber-300',
  'text-amber-700': 'dark:text-amber-200',
  'text-amber-800': 'dark:text-amber-100',
  'text-amber-900': 'dark:text-amber-50',
}

const darkBgColorMap = {
  // Gray
  'bg-white': 'dark:bg-gray-900',
  'bg-gray-50': 'dark:bg-gray-700',
  'bg-gray-100': 'dark:bg-gray-600', // Needs to be lighter than the others to be visible in cards,
  'bg-gray-200': 'dark:bg-gray-500',
  'bg-gray-300': 'dark:bg-gray-500',
  'bg-gray-400': 'dark:bg-gray-400',
  'bg-gray-500': 'dark:bg-gray-300',
  'bg-gray-600': 'dark:bg-gray-200',
  'bg-gray-900': 'dark:bg-white',

  // Green
  'bg-green-50': 'dark:bg-green-900',
  'bg-green-100': 'dark:bg-green-800',
  'bg-green-400': 'dark:bg-green-500',
  'bg-green-600': 'dark:bg-green-300',

  // Red
  'bg-red-50': 'dark:bg-red-900',
  'bg-red-100': 'dark:bg-red-800',
  'bg-red-300': 'dark:bg-red-600',

  // Yellow
  'bg-yellow-50': 'dark:bg-yellow-900',
  'bg-yellow-500': 'dark:bg-yellow-400',

  // Amber
  'bg-amber-50': 'dark:bg-amber-900',

  // Indigo
  'bg-indigo-50': 'dark:bg-indigo-900',
  'bg-indigo-100': 'dark:bg-indigo-800',
  'bg-indigo-200': 'dark:bg-indigo-700',
  'bg-indigo-400': 'dark:bg-indigo-500',
  'bg-indigo-600': 'dark:bg-indigo-300',

  // Blue
  'bg-blue-50': 'dark:bg-blue-900',
  'bg-blue-100': 'dark:bg-blue-800',

  // Purple
  'bg-purple-50': 'dark:bg-purple-900',
  'bg-purple-100': 'dark:bg-purple-800',

  // Pink
  'bg-pink-50': 'dark:bg-pink-900',
  'bg-pink-100': 'dark:bg-pink-800',

  // Orange
  'bg-orange-50': 'dark:bg-orange-900',
  'bg-orange-100': 'dark:bg-orange-800',
}

export function colorClasses(color) {
  if (!color) return null

  if (!darkColorMap[color]) console.log('No dark color defined for ' + color)

  return color + ' ' + darkColorMap[color]
}

export function bgColorClasses(color) {
  if (!color) return null

  if (!darkBgColorMap[color])
    console.log('No dark bg color defined for ' + color)

  return color + ' ' + darkBgColorMap[color]
}
